import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import gsap from 'gsap';
import "../components/estilos.css";
import Producto3D from './Producto3d';
import logo from '../components/Logo-Empatica-Horizontal copy.svg';
import { Link, useHistory } from "react-router-dom";

const textos = [
    {
        titulo: 'Quickpaymini:',
        subtitulo: 'El cajero inteligente que optimiza tu negocio',
        descripcion: 'QuickPayMini es la solución ideal para quienes necesitan eficiencia en un formato más reducido. Diseñado para mostradores pequeños o estaciones de autocobro, este equipo ofrece una experiencia de cobro fluida sin sacrificar funcionalidad ni estética.',
    },
    {
        titulo: 'Pagos en efectivo sin riesgos ni complicaciones',
        subtitulo: 'Diseñado para mostradores pequeños o estaciones de autocobro',
        descripcion: 'Cuenta con recicladores de billetes y monedas para aceptar pagos en efectivo, dar cambio en cualquier denominación y detectar dinero falso con sensores avanzados.',
    },
    {
        titulo: 'Automatización y estilo',
        subtitulo: 'Tecnología eficiente y diseño compacto',
        descripcion: 'La mejor opción para mejorar tu servicio sin ocupar demasiado espacio.',
    },
];

export default function Presentation() {
    const [index, setIndex] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const buttonRef = useRef();
    const componentRef = useRef();
    const [isComponentInView, setIsComponentInView] = useState(true);
    const [isScrollingUp, setIsScrollingUp] = useState(false);
    const lastScrollY = useRef(0);
    const menuItems = [
        "Inicio",
        "Productos",
        "EmpaticaPOS",
        "Herramientas para desarrollador",
        "Agendar demo"
    ];

    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const handleTouchStart = (e) => {
        touchStartX.current = e.changedTouches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].clientX;
        handleSwipe();
    };

    const handleSwipe = () => {
        if (touchStartX.current !== null && touchEndX.current !== null) {
            const distance = touchStartX.current - touchEndX.current;
            const threshold = 50; // mínimo para considerar swipe

            if (distance > threshold) {
                // Swipe izquierda
                setIndex((prevIndex) => (prevIndex + 1) % textos.length);
            } else if (distance < -threshold) {
                // Swipe derecha
                setIndex((prevIndex) => (prevIndex - 1 + textos.length) % textos.length);
            }

            // Reset refs
            touchStartX.current = null;
            touchEndX.current = null;
        }
    };


    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % textos.length);
        }, 10000); // 20,000 milisegundos = 20 segundos

        return () => clearInterval(interval);
    }, []);
    // Eliminamos el efecto de cambio automático
    useEffect(() => {
        gsap.fromTo(
            buttonRef.current,
            { y: 0 },
            { y: -15, repeat: -1, yoyo: true, ease: 'power1.inOut', duration: 1.5 }
        );

        const observer = new IntersectionObserver(
            ([entry]) => setIsComponentInView(entry.isIntersecting),
            { threshold: 0.1 }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            gsap.killTweensOf(buttonRef.current);
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentY = window.scrollY;
            if (currentY < lastScrollY.current) {
                setIsScrollingUp(true);
            } else {
                setIsScrollingUp(false);
            }
            lastScrollY.current = currentY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const section = document.getElementById(id.toLowerCase());
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    const showDesktopMenu = isComponentInView || isScrollingUp;
    const history = useHistory();

    return (
        <div ref={componentRef} className="w-full fondo-presentacion overflow-hidden pb-24" id="producto-estrella">
            {/* Menú Desktop */}
            <div className="hidden lg:block fixed top-0 left-1/2 -translate-x-1/2 w-[70%] bg-[#2D4E86] text-white p-2 rounded-b-full shadow-lg z-50 transition-opacity duration-500">
                <nav className="container mx-auto flex items-center justify-between">
                    <img src={logo} alt="Logo" className="h-auto w-36 hover:scale-105 transition-transform ml-6" />
                    <div className="flex items-center space-x-6 pr-6">
                        {menuItems.map((name) =>
                            name === "Agendar demo" ? (
                                <a
                                    href="https://crm.empatica.mx/widget/booking/k9COyXU6LpKeNG5XA45J"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-green-400 hover:bg-green-500 text-white font-bold px-3 py-1.5 text-sm rounded-full shadow-lg transition-all max-w-[140px] whitespace-nowrap truncate"
                                >
                                    {name}
                                </a>
                            ) : name === "Inicio" ? (
                                <Link
                                    key={name}
                                    to="/empaticapage"
                                    className="relative px-4 py-2 text-white font-medium hover:text-blue-300 transition-colors group"
                                >
                                    {name}
                                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
                                </Link>
                            ) : name.toLowerCase() === "EmpaticaPOS" ? (
                                <button
                                    key={name}
                                    onClick={() => history.push("/empaticapage/privado")}
                                    className="relative px-4 py-2 text-white font-medium hover:text-blue-300 transition-colors group"
                                >
                                    {name}
                                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
                                </button>
                            ) : (
                                <button
                                    key={name}
                                    onClick={() => scrollToSection(name)}
                                    className="relative px-4 py-2 text-white font-medium hover:text-blue-300 transition-colors group"
                                >
                                    {name}
                                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
                                </button>
                            )
                        )}
                    </div>
                </nav>
            </div>

            {/* Menú Mobile */}
            <div className="lg:hidden absolute top-0 left-0 w-full bg-[#2D4E86] text-white py-2 shadow-lg z-50">
                <nav className="container mx-auto px-4">
                    <div className="flex items-center justify-between">
                        <img src={logo} alt="Logo" className="h-auto w-32 md:w-36 hover:scale-105 transition-transform" />
                        <button className="p-2 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {isMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                    {isMenuOpen && (
                        <div className="mt-4 pb-4 space-y-2">
                            {menuItems.map((name) =>
                                name === "Agendar demo" ? (
                                    <a
                                        key={name}
                                        href="https://crm.empatica.mx/widget/booking/k9COyXU6LpKeNG5XA45J"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-blue-800 rounded transition-colors"
                                    >
                                        {name}
                                    </a>
                                ) : name === "Inicio" ? (
                                    <Link
                                        key={name}
                                        to="/empaticapage"
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-blue-800 rounded transition-colors"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {name}
                                    </Link>
                                ) : name.toLowerCase() === "EmpaticaPOS" ? (
                                    <button
                                        key={name}
                                        onClick={() => {
                                            history.push("/empaticapage/privado");
                                            setIsMenuOpen(false);
                                        }}
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-blue-800 rounded transition-colors"
                                    >
                                        {name}
                                    </button>
                                ) : (
                                    <button
                                        key={name}
                                        onClick={() => {
                                            scrollToSection(name);
                                            setIsMenuOpen(false);
                                        }}
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-blue-800 rounded transition-colors"
                                    >
                                        {name}
                                    </button>
                                )
                            )}
                        </div>
                    )}
                </nav>
            </div>

            {/* Versión Mobile */}
            <div className="lg:hidden md:hidden w-full flex flex-col justify-between"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}>
                <div className="z-20 flex flex-col justify-start mt-20 px-2 h-max-h-[240px] h-[270px]">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <h1 className="text-blue-900 text-2xl md:text-3xl font-bold leading-tight">{textos[index].titulo}</h1>
                            <h2 className="text-gray-800 mt-2 text-xl md:text-2xl font-semibold">{textos[index].subtitulo}</h2>
                            <p className="mt-2 text-gray-700 text-base md:text-lg">{textos[index].descripcion}</p>
                        </motion.div>
                    </AnimatePresence>

                    {/* Indicadores del carrusel (bolitas) */}
                    <div className="flex justify-center mt-4 space-x-2">
                        {textos.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIndex(i)}
                                className={`w-6 h-6 rounded-full mb-16 ${i === index ? 'bg-[#2D4E86]' : 'bg-gray-300'}`}
                                aria-label={`Ir a slide ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>

                <div className='flex justify-center'>
                    <div className="
                        w-[95%] 
                        sm:w-[80%] 
                        sm:h-[70%] 
                        bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] 
                        rounded-l-[220px] 
                        sm:rounded-l-[320px] 
                        md:w-[60%] 
                        lg:top-52 lg:h-[60%] lg:w-[50%] 
                        mt-10 
                        transition-all duration-300">
                        <div className="relative mt-4 mb-6 h-[280px] sm:h-[220px] md:h-auto scale-[1.1] sm:scale-100">
                            <Producto3D modelPath="/models/QPMINI.glb" />
                        </div>
                    </div>
                </div>

                <div className="w-full px-4 pb-6 mt-6">
                    <div>
                        <button
                            className="mt-10 bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white py-3 px-8 rounded-full text-lg font-medium hover:opacity-90 transition-opacity w-full shadow-xl"
                            onClick={() => window.open("https://quickpay.empatica.mx", "_blank")}>
                            Conoce más
                        </button>
                    </div>
                    <div>
                        <motion.button
                            ref={buttonRef}
                            onClick={() => scrollToSection("productos")}
                            className={`${isComponentInView ? 'relative' : 'hidden'} transform mt-10 lg:left-6 lg:translate-x-0 bg-[#2D4E86] text-white border-2 border-white rounded-full px-4 py-2 text-sm md:text-base font-bold hover:bg-white hover:text-[#2D4E86] transition-all duration-300 shadow-xl`}>
                            ↓ Ver productos
                        </motion.button>
                    </div>

                </div>
            </div>

            {/* Versión Tablet */}
            <div className="hidden md:flex lg:hidden w-full mt-28 relative flex-col items-center">
                {/* Contenedor de texto */}
                <div className="w-full px-8 flex flex-col items-center text-center z-20 min-h-[310px] mb-8">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.5 }}>
                            <h1 className="text-blue-900 text-3xl font-bold">{textos[index].titulo}</h1>
                            <h2 className="text-gray-800 mt-4 text-2xl font-semibold">{textos[index].subtitulo}</h2>
                            <p className="mt-4 text-gray-700 max-w-2xl text-2xl mx-auto">{textos[index].descripcion}</p>
                        </motion.div>
                    </AnimatePresence>

                    {/* Indicadores del carrusel (bolitas) */}
                    <div className="flex justify-center mt-6 space-x-2">
                        {textos.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIndex(i)}
                                className={`w-6 h-6 rounded-full ${i === index ? 'bg-[#2D4E86]' : 'bg-gray-300'}`}
                                aria-label={`Ir a slide ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>

                {/* Contenedor del modelo 3D */}
                <div className="w-full flex justify-end relative z-10">
                    <div className="w-[80%] bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] rounded-l-[200px] flex items-center justify-center py-8">
                        <div className="h-[400px] w-[400px]">
                            <Producto3D modelPath="/models/QPMINI.glb" />
                        </div>
                    </div>
                </div>

                {/* Botones */}
                <div className="w-full flex flex-col items-center space-y-6 mt-8 px-8">
                    <button
                        className="bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white py-3 px-8 rounded-full text-lg font-medium hover:opacity-90 transition-opacity shadow-xl w-full max-w-xs"
                        onClick={() => window.open("https://quickpay.empatica.mx", "_blank")}
                    >
                        Conoce más
                    </button>
                    <motion.button
                        ref={buttonRef}
                        onClick={() => scrollToSection("productos")}
                        className="bg-[#2D4E86] text-white border-2 border-white rounded-full px-4 py-2 text-base font-bold hover:bg-white hover:text-[#2D4E86] transition-all duration-300 shadow-xl">
                        ↓ Ver productos
                    </motion.button>
                </div>
            </div>

            {/* Versión Desktop */}
            <div className="hidden lg:flex w-full mt-28 relative">
                {/* Columna de texto */}
                <div className="w-1/2 flex flex-col justify-center pl-16 z-20 h-[500px] overflow-hidden">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.5 }}>
                            <h1 className="text-blue-900 text-4xl font-bold">{textos[index].titulo}</h1>
                            <h2 className="text-gray-800 mt-4 text-3xl font-semibold">{textos[index].subtitulo}</h2>
                            <p className="mt-4 text-gray-700 max-w-md text-xl">{textos[index].descripcion}</p>
                        </motion.div>
                    </AnimatePresence>

                    {/* Indicadores del carrusel (bolitas) - Desktop */}
                    <div className="flex mt-4 space-x-2">
                        {textos.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIndex(i)}
                                className={`w-3 h-3 rounded-full ${i === index ? 'bg-[#2D4E86]' : 'bg-gray-300'}`}
                                aria-label={`Ir a slide ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>

                <div className="w-1/2 flex items-center relative z-10">
                    <div className="h-[60vh] w-full bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] rounded-l-[300px] flex items-center justify-center">
                        <div className="h-[500px] w-[500px]">
                            <Producto3D modelPath="/models/QPMINI.glb" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="hidden lg:flex flex-col items-start space-y-6 mb-48 ml-2">
                <button
                    className="bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white py-3 px-8 rounded-full text-lg font-medium hover:opacity-90 transition-opacity shadow-xl"
                    onClick={() => window.open("https://quickpay.empatica.mx", "_blank")}
                >
                    Conoce más
                </button>
                <motion.button
                    ref={buttonRef}
                    onClick={() => scrollToSection("productos")}
                    className="bg-[#2D4E86] text-white border-2 border-white rounded-full px-4 py-2 text-base font-bold hover:bg-white hover:text-[#2D4E86] transition-all duration-300 shadow-xl">
                    ↓ Ver productos
                </motion.button>
            </div>
        </div>
    );

}